// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { partialRight } from 'lodash'
import { Field } from 'redux-form'
import { assignRadioFamily, assignSuggestValue } from './helpers'
import scrubForCSV from '../scrubForCSV'
import { clearDbSearchForm } from 'redux/modules/databaseSearches'
import { ActionButtons } from '../../common'

import {
  InfoLabel,
  LabeledInput,
  RadioCompanies,
  RadioModelFamilies,
  RadioModelNumber,
} from 'components/Form'

const cn = 'companyName'
const mn = 'modelNumber'
const rfn = 'radioFamily'

const inputRowClass = 'display-flex justify-content-between align-items-start flex-wrap-nowrap'
const liw = {
  width: '15%',
}

const emissionBwLabel = (
  <InfoLabel
    label={'Emission Bandwidth (MHz)'}
    info={'Occupied bandwidth of the radio in MHz'} />
)

const BasicSearch = ({ change, exportResults, hasResults, idRoot, sourceForm }) => {
  const scrubAndExport = () => exportResults(scrubForCSV) // avoids click event

  return ([
    <ul
      key={'radio-basic-top'}
      className={inputRowClass}>
      <li style={liw}>
        <Field
          autoFocus={true}
          component={LabeledInput}
          id={`${idRoot}radio-code`}
          label={'Code'}
          placeholder={'Code'}
          name={'radioCode'} />
      </li>
      <li style={liw}>
        <RadioCompanies
          handleSelection={partialRight(assignSuggestValue, cn, change)}
          idRoot={idRoot}
          name={cn} />
      </li>
      <li style={liw}>
        <RadioModelFamilies
          handleSelection={partialRight(assignRadioFamily, rfn, change)}
          idRoot={idRoot}
          name={`${rfn}Name`} />
      </li>
      <li style={liw}>
        <RadioModelNumber
          handleSelection={partialRight(assignSuggestValue, mn, change)}
          idRoot={idRoot}
          name={mn} />
      </li>
      <li
        className={'database-search-actions position-relative'}
        style={liw}>
        <ActionButtons
          clearForm={clearDbSearchForm}
          dbSet={'radio'}
          exportResults={scrubAndExport}
          hasResults={hasResults}
          idRoot={idRoot}
          sourceForm={sourceForm} />
      </li>
    </ul>,
    <ul
      key={'radio-basic-bottom'}
      className={inputRowClass}>
      <li style={liw}>
        <Field
          component={LabeledInput}
          id={`${idRoot}bandwidth`}
          label={emissionBwLabel}
          placeholder={'Number or Min : Max'}
          name={'bandwidth'} />
      </li>
      <li style={liw}>
        <Field
          component={LabeledInput}
          id={`${idRoot}frequency`}
          label={'Frequency (MHz)'}
          placeholder={'Number or Min : Max'}
          name={'frequency'} />
      </li>
      <li style={liw} />
      <li style={liw} />
      <li style={liw} />
    </ul>,
  ])
}

BasicSearch.propTypes = {
  change: func.isRequired,
  exportResults: func.isRequired,
  hasResults: bool.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default BasicSearch
